"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_final_form_1 = require("react-final-form");
var constants_1 = require("containers/TableMaker/constants");
var validators_1 = require("utils/form/validators");
var EmailHeadersCell_1 = __importDefault(require("./EmailHeadersCell"));
var EmailHeadersRow_1 = __importDefault(require("./EmailHeadersRow"));
var RemoveBtnCell_1 = __importDefault(require("./RemoveBtnCell"));
var TableFieldText_1 = __importStar(require("./TableFieldText"));
var XL = constants_1.CellSize.XL, LG = constants_1.CellSize.LG, XSM = constants_1.CellSize.XSM;
var validateRow = function (_a) {
    var _b = _a === void 0 ? {} : _a, name = _b.name, email = _b.email;
    var emailError = name || email ? (0, validators_1.getEmailError)(email !== null && email !== void 0 ? email : '') : undefined;
    return emailError ? { email: emailError } : undefined;
};
var CCEmailRow = function (_a) {
    var handleDelete = _a.handleDelete, canDelete = _a.canDelete, disabled = _a.disabled, name = _a.name;
    var onChange = (0, react_final_form_1.useField)(name, { validate: validateRow }).input.onChange;
    var handleClear = function () { return onChange({}); };
    var handleClick = function () { return !canDelete ? handleClear() : handleDelete === null || handleDelete === void 0 ? void 0 : handleDelete(); };
    return ((0, jsx_runtime_1.jsxs)(EmailHeadersRow_1.default, { children: [(0, jsx_runtime_1.jsx)(EmailHeadersCell_1.default, __assign({ width: XL + XSM + 4 }, { children: (0, jsx_runtime_1.jsx)(TableFieldText_1.TableFieldEmail, { name: "".concat(name, ".email"), disabled: disabled, validate: undefined }) })), (0, jsx_runtime_1.jsx)(EmailHeadersCell_1.default, __assign({ width: LG + 8 }, { children: (0, jsx_runtime_1.jsx)(TableFieldText_1.default, { name: "".concat(name, ".name"), disabled: disabled, placeholder: "Name" }) })), (0, jsx_runtime_1.jsx)(RemoveBtnCell_1.default, { tooltipTitle: canDelete ? 'Delete' : 'Clear', onClick: handleClick, disabled: disabled })] }));
};
exports.default = CCEmailRow;
